import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {

  constructor(private router: Router) { }
  public displayImage: boolean = false;
  public selectedImage: any;
  public imageList = [
    { src: '../../assets/images/Artboard 4.png', title: 'Right Test' },
    { src: '../../assets/images/Artboard 5.png', title: 'Right Patient Preparation' },
    { src: '../../assets/images/Artboard 6.png', title: 'Right Sample' },
    { src: '../../assets/images/Artboard 7.png', title: 'Right Method' },
    { src: '../../assets/images/Artboard 8.png', title: 'Right Report' },
    { src: '../../assets/images/Artboard 9.png', title: 'Right Interpretation' }
  ];

  private currentIndex = 0;
  private isScrolling = false;

  @ViewChild('valuesSection', { read: ElementRef })
  public testimonials!: ElementRef;

  @ViewChildren('section')
  sections!: QueryList<ElementRef>;

  ngAfterViewInit(): void {
    // Start at first section
    this.scrollToSection(0);
  }

  // ==============================
  // FULL PAGE SCROLL (MOUSE)
  // ==============================

  // @HostListener('wheel', ['$event'])
  onWheel(event: WheelEvent) {

    if (this.isScrolling) return;

    if (event.deltaY > 0) {
      this.goNext();
    } else {
      this.goPrevious();
    }
  }

  // ==============================
  // FULL PAGE SCROLL (KEYBOARD)
  // ==============================

  // @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {

    if (this.isScrolling) return;

    switch (event.key) {

      case 'ArrowDown':
      case 'PageDown':
        event.preventDefault();
        this.goNext();
        break;

      case 'ArrowUp':
      case 'PageUp':
        event.preventDefault();
        this.goPrevious();
        break;

      case ' ':
        event.preventDefault();
        this.goNext();
        break;
    }
  }

  // ==============================
  // SECTION NAVIGATION
  // ==============================

  private goNext(): void {
    if (this.currentIndex < this.sections.length - 1) {
      this.currentIndex++;
      this.scrollToSection(this.currentIndex);
    }
  }

  private goPrevious(): void {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.scrollToSection(this.currentIndex);
    }
  }

  private scrollToSection(index: number): void {

    this.isScrolling = true;
    this.currentIndex = index;

    // If top section → force absolute top
    if (index === 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      const element = this.sections.toArray()[index].nativeElement;

      const offsetTop = element.offsetTop;

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth'
      });
    }

    setTimeout(() => {
      this.isScrolling = false;
    }, 900);
  }

  // ==============================
  // TESTIMONIALS HORIZONTAL SCROLL
  // ==============================

  public scrollRight(): void {
    if (window.innerWidth > 600) {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft + 600,
        behavior: 'smooth'
      });
    } else {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft + window.innerWidth,
        behavior: 'smooth'
      });
    }
  }

  public scrollLeft(): void {
    if (window.innerWidth > 600) {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft - 650,
        behavior: 'smooth'
      });
    } else {
      this.testimonials.nativeElement.scrollTo({
        left: this.testimonials.nativeElement.scrollLeft - window.innerWidth,
        behavior: 'smooth'
      });
    }
  }
  ngOnInit(): void {
  }

  onClickImage(image) {
    this.selectedImage = image;
    this.displayImage = true;
  }

  onClickExploreCourses() {
    this.router.navigate(['courses']);
    sessionStorage.setItem('activeSection', JSON.stringify('courses'));
  }

}
